import * as React from 'react';
import styled from 'styled-components';

interface IImageProps {
    altText: string;
    onLoad: React.ReactEventHandler<HTMLImageElement>;
    onError: React.ReactEventHandler<HTMLImageElement>;
    role: string;
    showImage: boolean;
    src: string;
}

export const Image = ({ onError, altText, showImage, onLoad, role, src }: IImageProps) => {
    return (
        <Img onError={onError} alt={altText} aria-hidden={!showImage} onLoad={onLoad} role={role} src={src} style={{ opacity: showImage ? 1 : 0 }} />
    );
};

export const Img = styled.img`
    width: 100%;
    display: flex;
    transition: opacity ease-in-out 0.2s;
    transition-delay: 0.5s;

    &[aria-hidden='true'] {
        opacity: 0;
    }
`;
